import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}visa-vendor-additional-service`;

export function getVisaVendorAddotionalServices(params) {
  return http.get(apiUrl, { params });
}

export function getVisaVendorAddotionalService(id) {
  return http.get(`${apiUrl}/${id}`);
}

export function createMultiVisaVendorAddotionalService(data) {
  return http.post(`${apiUrl}/multiple`, data);
}

export function visaVendorUploadLoanScanCopy(id, formData) {
  return http.post(`${apiUrl}/upload-scan-copy/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function saveVisaVendorAddotionalService(data) {
  if (data.id) return http.patch(`${apiUrl}/${data.id}`, data);
  return http.post(apiUrl, data);
}

export function approveVisaVendorAddotionalService(id, data) {
  return http.patch(`${apiUrl}/approve/${id}`, data);
}

export function deleteVisaVendorAddotionalService(id) {
  return http.delete(`${apiUrl}/${id}`);
}
